import http from "./http";
import { IncompleteScreeningForm } from "./screeningEditEligibility";

type FetchIncompleteSummaryOptions = {
  studyId?: string;
  isRegistry?: boolean;
};

export async function fetchIncompleteScreeningSummary(
  participantId: string,
  screeningAttemptId: string,
  options: FetchIncompleteSummaryOptions = {}
): Promise<IncompleteScreeningForm[]> {
  const params = { participantId };
  const url =
    options.isRegistry || !options.studyId
      ? `/registry/admin-screening-responses/attempt/${screeningAttemptId}/incomplete-summary`
      : `/study/${options.studyId}/admin-screening-responses/attempt/${screeningAttemptId}/incomplete-summary`;

  const res = await http.get(url, { params });
  return res.data?.data?.forms ?? [];
}
